import { axiosAjax } from '@app/src/config/axios';
import { FreeExtrachargeModel } from '@app/src/views/StepOne/form/models/freeExtracharge';
import { hydrateData } from './hydrators';
import { isClientEnv } from '@app/src/utils/validations';

export const freeExtrachargeService = {
  async get(categoryId: number): Promise<FreeExtrachargeModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
          process.env.API_FREE_EXTRACHARGE
            .replace(':categoryId', String(categoryId)),
            config
        )
      if (data.error) {
        throw new Error();
      }
      return data.data && hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
